import { Component, input } from '@angular/core';

@Component({
  selector: 'app-panel',
  standalone: true,
  host: {
    '[class.panel-host--fill-height]': 'fillHeight()',
  },
  template: `
    <section
      class="panel"
      [class.has-padding]="padded()"
      [class.panel--seamless]="seamless()"
      [class.panel--fill-height]="fillHeight()"
    >
      <ng-content></ng-content>
    </section>
  `,
  styles: [
    `
      :host.panel-host--fill-height {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        align-self: stretch;
        width: 100%;
      }

      .panel {
        border: 1px solid var(--border);
        border-radius: 14px;
        background: var(--surface-elevated);
      }

      .panel.has-padding {
        padding: 14px;
      }

      /* Bloco dentro de superfície única (ex.: detalhe do card estilo ClickUp). */
      .panel--seamless {
        border: none;
        border-radius: 0;
        background: transparent;
        box-shadow: none;
      }

      .panel--seamless.has-padding {
        padding: 16px 18px;
      }

      /* Coluna com scroll interno (ex.: comentários no modal). */
      .panel--fill-height {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
      }
    `,
  ],
})
export class PanelComponent {
  readonly padded = input<boolean>(true);
  /** Sem borda própria — agrupa-se num wrapper com borda única. */
  readonly seamless = input(false);
  /** Preenche altura do flex pai (`min-height: 0` para permitir overflow nos filhos). */
  readonly fillHeight = input(false);
}
